<template>
  <div class="app-container">
    <div class="ceiling">
      <home-top></home-top>
      <navicat background="#ffffff" :current="1"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content w-1400">
      <div class="mau">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <router-link to="/shop">商城</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <router-link to="/shop/settlement">结算中心
            </router-link>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="body-content">
        <div class="inner">
          <div class="address-title">
            <span class="desc-name">收货地址</span>
            <el-button type="text" @click="addressAddDialog = true"><i class="el-icon-plus"></i> 新增收货地址
            </el-button>
          </div>
          <div class="inner-box">
            <div class="tag-box">
              <el-radio v-if="defaultAddress" class="radio-item" v-model="addressRadioModel" label="1" border>
                <div class="radio-box-item">
                  <div class="radio-box">
                    <div class="radio-box-top">
                      <span>{{ defaultAddress.name }}</span>
                      <span>{{ defaultAddress.phone }}</span>
                    </div>
                    <div class="radio-box-fotter">
                      <span>{{ defaultAddress.province }} {{ defaultAddress.city }}
                        {{ defaultAddress.area }}
                        {{ defaultAddress.address }}</span>
                    </div>
                  </div>
                  <!-- <div class="default-address">默认地址</div> -->
                </div>
              </el-radio>
            </div>
            <el-collapse v-model="activeNamesAddress" @change="haAddress">
              <el-collapse-item name="2">
                <template slot="title">
                  {{
                    activeNamesAddress.includes("2")
                        ? "收起所有地址"
                        : "展开所有地址"
                  }}<i class="el-icon-arrow-down"></i>
                </template>
                <el-radio-group v-model="addressRadio" @input="handleChangeAddress">
                  <div class="tag-box">
                    <el-radio class="radio-item" v-for="item in addressList" :key="item.id" :label="item.id" border>
                      <div class="radio-box-item">
                        <div class="radio-box">
                          <div class="radio-box-top">
                            <span>{{ item.name }}</span>
                            <span>{{ item.phone }}</span>
                          </div>
                          <div class="radio-box-fotter">
                            <span>{{ item.province }} {{ item.city }}
                              {{ item.area }} {{ item.address }}</span>
                          </div>
                        </div>
                        <div class="radio-box-item-footer">
                          <div class="radio-box-item-footer-top">
                            <el-button type="text" @click.stop="handleEditAddress(item)">编辑</el-button>
                            <el-button type="text" @click.stop="handleDeleteAddress(item)">删除</el-button>
                          </div>
                          <input @click.stop="handleDefaultAddress(item)" type="radio" name="group_name"
                                 :value="item.id"
                                 :checked="item.is_default" :id="item.id">
                          <label :for="item.id">默认地址</label>
                        </div>
                      </div>
                    </el-radio>
                  </div>
                </el-radio-group>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="inner">
          <div class="address-title">
            <span class="desc-name">发票抬头</span>
            <el-button type="text" @click="handleAddInvoice"><i class="el-icon-plus"></i> 新增发票抬头
            </el-button>
          </div>
          <div class="inner-box">
            <div class="tag-box">
              <el-radio v-if="defaultInvoice" class="radio-item" v-model="invoiceRadioModel" label="1" border>
                <div class="radio-box-item">
                  <div class="radio-box">
                    <div class="radio-box-top">
                      <span>{{ defaultInvoice.title }}</span>
                      <span>{{ defaultInvoice.tax_number }}</span>
                    </div>
                    <div class="radio-box-fotter">
                      <span>{{ defaultInvoice.address || "" }}</span>
                    </div>
                  </div>
                  <div class="default-address"></div>
                </div>
              </el-radio>
            </div>
            <el-collapse v-model="activeNames" @change="haInvoice">
              <el-collapse-item name="1">
                <template slot="title">
                  {{
                    activeNames.includes("1")
                        ? "收起所有发票抬头"
                        : "展开所有发票抬头"
                  }}<i class="el-icon-arrow-down"></i>
                </template>
                <el-radio-group v-model="invoiceRadio" @input="handleChangeInvoice">
                  <div class="tag-box">
                    <el-radio class="radio-item" v-for="(item,index) in invoiceList" :key="item.id" :label="item.id"
                              border>
                      <div class="radio-box-item">
                        <div class="radio-box">
                          <div class="radio-box-top">
                            <span>{{ item.title }}</span>
                            <span>{{ item.tax_number }}</span>
                          </div>
                          <div class="radio-box-fotter">
                            <span>{{ item.address || '' }}</span>
                          </div>
                        </div>
                        <div class="radio-box-item-footer">
                          <div class="radio-box-item-footer-top">
                            <el-button type="text" @click="handleEditInvoice(item)">编辑</el-button>
                            <el-button type="text" @click="handleDeleteInvoice(item)">删除</el-button>
                          </div>
                          <!--                          <input @click="handleDefaultAddress(item)" type="radio" name="group_name" :value="item.id"-->
                          <!--                                 :checked="index==0" :id="item.id">-->
                          <!--                          <label :for="item.id">默认发票</label>-->
                        </div>
                      </div>
                    </el-radio>
                  </div>
                </el-radio-group>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="table-box">
          <div class="title-box">确认订单信息</div>
          <div class="table-inner">
            <el-table :data="selectedList" style="width: 100%" :header-cell-style="{
              backgroundColor: '#F6F6F8',
              color: '#999999',
            }">
              <el-table-column prop="product_name" label="商品名称"/>
              <el-table-column prop="cas_no" label="CAS"/>
              <!--              <el-table-column prop="sku" label="规格">-->
              <!--                <template slot-scope="scope">-->
              <!--                  {{ scope.row.sku }}-->
              <!--                </template>-->
              <!--              </el-table-column>-->

              <el-table-column prop="weight" label="重量"/>
              <el-table-column prop="purity" label="纯度"/>
              <el-table-column prop="custorm_price" label="单价"/>
              <el-table-column label="数量" width="250">
                <template slot-scope="scope">
                  <el-input-number size="mini" :min="1" :max="100" v-model="scope.row.num"
                                   @change="handleChangeNum(scope.row)"/>
                </template>
              </el-table-column>
              <el-table-column prop="fellPrice" label="运费">
                <template slot-scope="scope">
                  {{ scope.row.fellPrice }}元
                </template>
              </el-table-column>
              <el-table-column label="小计">
                <template slot-scope="scope">
                  <span class="all-price">
                    {{
                      Number(
                          Number(scope.row.custorm_price) * Number(scope.row.num) + Number(scope.row.fellPrice)).toFixed(2)
                    }}
                  </span>
                  <span class="all-price-unit">元</span>
                </template>
              </el-table-column>
              <el-table-column label="发票类型">
                普票
              </el-table-column>
            </el-table>
          </div>
          <div class="table-box">
            <div class="title-box remark-title">备注</div>
            <el-input v-model="remark" type="textarea" placeholder="请输入备注">
            </el-input>
          </div>
          <div class="table-footer">
            <span class="table-footer-text">合计金额：</span>
            <span class="table-footer-price">￥{{ allPrice }}</span>
          </div>
          <div class="table-footer">
            <span class="table-footer-text">实付款：</span>
            <span class="table-footer-big">￥{{ allPrice }}</span>
          </div>
        </div>
        <div class="table-button">
          <gradient-button height="40px" width="150px" border="1px solid #336ED2" background="#E9F1FE" color="#0C60E6"
                           @hit="handleBack">返回上一步
          </gradient-button>
          <gradient-button @hit="handleSubmit" height="40px" width="150px" background="#0C60E6">提交订单
          </gradient-button>
        </div>
      </div>
      <add-addresss :id="editAddressId" :addressAddDialog="addressAddDialog" @close="addressAddClose"
                    @success="addressSuccess"/>
      <add-invoicing :invoicingeAddDialog="invoicingAddDialog" @close="invoicingAddClose" @success="invoicingSuccess"
                     :id="invoicingId"/>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeFooter from "@/components/public/home-footer.vue";
import homeTop from "@/components/public/home-top.vue";
import navicat from "@/components/navicat/navicat.vue";
import gradientButton from "@/components/button/gradient-button.vue";
import addAddresss from "@/components/addInfo/add_addresss.vue";
import addInvoicing from "@/components/addInfo/add_invoicing.vue";
import {
  create_order_by_cart,
  getUserAddress,
  invoiceList,
  changeNum,
  create_order_buy_now,
  addressDelete,
  addressUpdate, invoiceDelete, calculateShippingCost
} from "@/api/modules/user";
import {getDefault, getInvoice} from "@/api/modules/common";
import {detailApi} from "@/api/modules/home";

export default {
  name: "settlement",
  components: {
    homeTop,
    navicat,
    gradientButton,
    addAddresss,
    addInvoicing,
    homeFooter,
  },
  data() {
    return {
      radio1: "1",
      type: this.$route.query.type,
      selectedList: [],
      price_unit: "",
      activeNames: [""],
      activeNamesAddress: [""],
      // 默认地址
      defaultAddress: {},
      // 默认发票
      defaultInvoice: {},
      // 添加地址弹窗
      addressAddDialog: false,
      // 添加发票弹窗
      invoicingAddDialog: false,
      // 地址列表
      addressList: [],
      // 发票列表
      invoiceList: [],
      // 地址radio
      addressRadio: "",
      // 发票radio
      invoiceRadio: "",
      // 订单详情
      orderDetail: [],
      invoicingId: '',
      addressRadioModel: "1",
      invoiceRadioModel: "1",
      remark: "",
      num: 1,
      tableData: [],
      fristAddress: true,
      fristInvoice: true,
      editAddressId: '',
    };
  },
  computed: {
    allPrice() {
      return this.selectedList
          .reduce((total, item) => {
            return total + (item.custorm_price * item.num) + Number(item.fellPrice);
          }, 0)
          .toFixed(2);
    },
  },
  created() {
    this.selectedList = this.$store.getters.settlement_list;
    this.selectedList.forEach((item) => {
      item.fellPrice = ''
    })
  },
  mounted() {
    this.init();
  },
  methods: {

    haAddress(e) {
      if (e.includes("2") || this.fristAddress) {
        this.fristAddress = false;
      }
    },
    haInvoice(e) {
      if (e.includes("1") || this.fristInvoice) {
        this.fristInvoice = false;
        this.getInvoiceList();
      }
    },
    // 添加发票
    handleAddInvoice() {
      this.invoicingAddDialog = true;
    },
    handleEditInvoice(item) {
      this.invoicingId = item.id
      this.invoicingAddDialog = true;
    },
    handleDeleteInvoice(item) {
      this.$confirm('确定删除该发票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        invoiceDelete(item.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: "删除成功",
              type: "success",
              offset: 300,
            });
            this.getInvoiceList()
          } else {
            this.$message.error({
              message: res.data.message,
              type: "error",
              offset: 300,
            });
          }
        })
      })

    },
    handleChangeNum(row) {

      if (this.type) {
        this.getFellPrice()
      } else {
        this.getFellPrice(true, row)
      }

    },
    handleDefaultAddress(item) {
      let data = {
        district: [item.provinceId, item.cityId, item.areaId],
        address: item.address,
        is_default: 1,
        name: item.name,
        phone: item.phone,
      }
      addressUpdate(item.id, data).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: "设置成功",
            type: "success",
            offset: 300,
          });
        } else {
          this.$message.error({
            message: res.data.message,
            type: "error",
            offset: 300,
          });
        }
      });

    },
    // 提交订单
    handleSubmit() {
      if (!this.addressRadio) {
        this.$message.error({
          message: "请选择收货地址",
          type: "error",
          offset: 300,
        });
        return;
      }
      if (!this.invoiceRadio) {
        this.$message.error({
          message: "请选择发票",
          type: "error",
          offset: 300,
        });
        return;
      }
      if (this.type) {
        // 单规格立即提交
        this.handleSubmitOne();
      } else {
        // 购物车购买
        this.handleSubmitBuyNow();
      }

    }, // 单规格立即提交
    handleSubmitOne() {
      if (!this.mixCheckUserAudit()) {
        return
      }
      let data = {
        address_id: this.addressRadio,
        invoice_id: this.invoiceRadio,
        shop_product_id: this.selectedList[0].id,
        number: this.selectedList[0].num,
        express_price: this.selectedList[0].fellPrice,
        remark: this.remark,
      };
      if (this.type == "more") {
        data.sku = this.selectedList[0].sku;
      }
      create_order_buy_now(data).then((res) => {
        if (res.data.code === 10000) {
          this.$router.push({
            path: "/shop/bay",
            query: {
              order_id: res.data.data,
            },
          });
        }
      });
    },
    //  购物车购买
    handleSubmitBuyNow() {
      create_order_by_cart({
        address_id: this.addressRadio,
        invoice_id: this.invoiceRadio,
        cart_ids: this.selectedList.map((item) => item.id),
        remark: this.remark,
      }).then((res) => {
        if (res.data.code === 10000) {
          this.$router.push({
            path: "/shop/bay",
            query: {
              order_no: res.data.data,
            },
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            type: "error",
            offset: 300,
          });
        }
      });
    },
    addressSuccess() {
      this.getAddressList();
      this.getAddress();
      this.editAddressId = ''
    },
    invoicingSuccess() {
      this.getInvoiceList();
      this.getInvoice();
    },
    handleEditAddress(item) {
      this.addressAddDialog = true;
      this.editAddressId = item.id;
    },
    handleDeleteAddress(item) {
      if (item.is_default) {
        this.$message.error({
          message: "默认地址不能删除",
          type: "error",
          offset: 300,
        });
        return
      }
      if (this.addressRadio == item.id) {
        this.$message.error({
          message: "当前地址不能删除",
          type: "error",
          offset: 300,
        });
        return
      }
      this.$confirm('确定删除该地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        addressDelete(item.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: "删除成功",
              type: "success",
              offset: 300,
            });
            this.getAddressList();
          }
        })
      })
    },
    // 切换地址
    handleChangeAddress(e) {
      this.activeNamesAddress = [""]
      // 设置默认地址
      this.defaultAddress = this.addressList.find((item) => item.id === e);
      // 计算运费
      this.getFellPrice()
    },
    // 切换发票
    handleChangeInvoice(e) {
      this.activeNames = ['']
      this.defaultInvoice = this.invoiceList.find((item) => item.id === e);
    },
    addressAddClose(e) {
      this.addressAddDialog = e;
    },
    invoicingAddClose(e) {
      this.invoicingAddDialog = e;
    },
    init() {
      this.getAddress();
      this.getInvoice();
      this.getAddressList();
    },
    // 获取订单详情
    getOrderDetail() {
      detailApi(this.id).then((res) => {
        if (res.data.code === 10000) {
          this.orderDetail = [res.data.data];
          this.orderDetail[0].num = 1;
          if (this.sku) {
            this.price_unit = res.data.data.sku.find(
                (item) => item.sku == this.sku
            ).price;
          }
        } else {
          this.$message.error({
            message: res.data.msg,
            type: "error",
            offset: 100,
          });
        }
      });
    },
    // 获取默认发票
    getInvoice() {
      getInvoice().then((res) => {
        this.defaultInvoice = res.data.data;
        if (this.defaultInvoice) {
          this.invoiceRadio = res.data.data.id;
        }
      });
    },
    // 获取默认地址
    getAddress() {
      getDefault().then((res) => {
        this.defaultAddress = res.data.data;
        if (this.defaultAddress) {
          this.addressRadio = res.data.data.id;
          if (this.type) {
            this.getFellPrice(true)
          } else {
            this.getShopFellPrice()
          }
        }
      });
    },
    async getShopFellPrice() {
      for (let i = 0; i < this.selectedList.length; i++) {
        let data = {
          provinceId: this.defaultAddress.provinceId,
          weight: this.selectedList[i].weight,
          number: this.selectedList[i].num,
          supply_id: this.selectedList[i].supply_id,
        };
        calculateShippingCost(data).then((res) => {
          if (res.data.code === 10000) {

            this.$set(this.selectedList, i, {
              ...this.selectedList[i],
              fellPrice: res.data.data
            });
            changeNum(this.selectedList[i].id, {
              cart_num: this.selectedList[i].num,
              express_price: res.data.data
            }).then(res => {
              if (res.data.code === 10000) {
                // this.$message.success({
                //   message: "更新成功",
                //   type: "success",
                //   offset: 300,
                // });
              }
            })
          }
        });
      }

    },
    async getFellPrice(isChangeNum, row) {
      let otherPost = isChangeNum || false
      for (let i = 0; i < this.selectedList.length; i++) {
        let data = {
          provinceId: this.defaultAddress.provinceId,
          weight: this.selectedList[i].weight,
          number: this.selectedList[i].num,
          supply_id: this.selectedList[i].supply_id,
        };
        calculateShippingCost(data).then((res) => {
          if (res.data.code === 10000) {

            this.$set(this.selectedList, i, {
              ...this.selectedList[i],
              fellPrice: res.data.data
            });
            if (otherPost&&row) {
              if (row.id == this.selectedList[i].id) {
                changeNum(row.id, {cart_num: row.num, express_price: res.data.data})
              }

            }
          }
        });
      }
    },
    // 获取地址列表
    getAddressList() {
      getUserAddress().then((res) => {
        this.addressList = res.data.data.data;
      });
    },
    // 获取发票列表
    getInvoiceList() {
      invoiceList().then((res) => {
        this.invoiceList = res.data.data.data;
      });
    },

    // 返回上一步
    handleBack() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.h-top {
  // height: 142px;
  height: 120px;
}

.radio-box-item-footer {
  text-align: right;

  .radio-box-item-footer-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  label {
    color: #409EFF !important;
  }

  .el-button {
    margin-right: 10px;
  }
}

::v-deep .el-radio__label {
  width: 100% !important;
}

::v-deep .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}

::v-deep .el-collapse-item__header {
  border-bottom: none !important;
}

::v-deep .el-radio {
  margin-right: 0 !important;
}

::v-deep .el-radio-button__inner,
.el-radio-group {
  display: block !important;
}

.remark-title {
  padding: 20px 0;
}

.content {
  padding-bottom: 100px;

  .mau {
    padding: 20px 30px;
  }

  .table-box {
    .title-box {
      font-weight: bold;
      font-size: 18px;
      color: #00112b;
    }

    .table-inner {
      border: 1px solid #eeeeee;
      margin-top: 20px;

      .all-price {
        font-weight: bold;
        font-size: 18px;
        color: #ff4400;
      }

      .all-price-unit {
        font-weight: bold;
        font-size: 16px;
        color: #ff4400;
      }
    }

    .table-footer {
      text-align: right;
      padding-top: 25px;

      .table-footer-text {
        font-weight: 400;
        font-size: 18px;
        color: #5f616c;
      }

      .table-footer-price {
        font-weight: bold;
        font-size: 18px;
        color: #ff4400;
      }

      .table-footer-big {
        font-weight: bold;
        font-size: 26px;
        color: #ff4400;
      }
    }
  }

  .table-button {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 20px;
  }

  .body-content {
    padding: 20px 30px;
    background-color: #ffffff;

    .inner {
      .address-title {
        padding: 30px 0;

        .desc-name {
          font-weight: bold;
          font-size: 18px;
          color: #00112b;
          display: inline-block;
          margin-right: 24px;
        }
      }

      .inner-box {
        .tag-box {
          display: flex;
          flex-direction: column;
          gap: 20px;

          .radio-item {
            height: 98px;
            background: rgba(12, 96, 230, 0.06);
            display: flex;
            align-items: center;
            padding: 0 40px;
          }

          .default-address {
            font-weight: 400;
            font-size: 18px;
            color: #afafaf;
          }

          .radio-box-item {
            flex: 1;
            display: flex;
            width: 100%;
          }

          .radio-box {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 24px;
            gap: 10px;

            .radio-box-top {
              display: flex;
              font-weight: bold;
              font-size: 18px;
              color: #333333;
              gap: 15px;
            }

            .radio-box-fotter {
              font-weight: 400;
              font-size: 18px;
              color: #5f616c;
            }
          }
        }
      }
    }

    .table-button {
      display: flex;
      justify-content: flex-end;
      gap: 20px;
      margin-top: 20px;
    }

    .table-box {
      .title-box {
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
      }

      .table-inner {
        border: 1px solid #eeeeee;
        margin-top: 20px;

        .all-price {
          font-weight: bold;
          font-size: 18px;
          color: #ff4400;
        }

        .all-price-unit {
          font-weight: bold;
          font-size: 16px;
          color: #ff4400;
        }
      }

      .table-footer {
        text-align: right;
        padding-top: 25px;

        .table-footer-text {
          font-weight: 400;
          font-size: 18px;
          color: #5f616c;
        }

        .table-footer-price {
          font-weight: bold;
          font-size: 18px;
          color: #ff4400;
        }

        .table-footer-big {
          font-weight: bold;
          font-size: 26px;
          color: #ff4400;
        }
      }
    }
  }
}
</style>
